<template>
  <v-container fluid scroll-region transition="scroll-x-transition">
    <v-row align="center" class="pt-6">
      <template v-for="block in template">
        <component
          :is="block.component"
          :key="block.uid"
          v-model="form[block.uid]"
          :block="block"
        />
      </template>
    </v-row>
    <v-row align="center">
      <v-col cols="12">
        <v-btn v-if="activeTab !== 'complete'" block class="bar-btn primary_light white--text" text dark :loading="loading" @click="save">
          Speichern & Weiter
        </v-btn>
        <v-btn v-else block class="bar-btn primary_light white--text" text dark :loading="loading" @click="complete">
          Speichern & Abschließen
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import QuestionnaireLayout from '@/Layouts/Questionnaire'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Loading...',
      }
   },
   provide () {
      const returnobject = {}
      for (const key in this.toProvide) {
         returnobject[key] = () => this.toProvide[key]
      }
      return returnobject
   },
   layout: (h, page) => h(QuestionnaireLayout, [page]),
   props: {
      template: {
         type: Array,
         required: true,
      },
      old: {
         type: Object,
         required: true,
      },
      title: {
         type: String,
         required: true,
      },
      token: {
         type: String,
         required: true,
      },
      provide: {
         type: Object,
         default () { return {} }
      }
   },

   data () {
      return {
         panel: [],
         user: 0,
         sending: false,
         form: this.$inertia.form(this.old),
         loading: false
      }
   },

   computed: {
      toProvide: function () {
         return this.provide
      },
      activeTab: function () {
         const url = new URL(window.location.href)
         const split = url.pathname.split('step').pop()
         return split.replace('/', '')
      }
   },

   watch: {
      old: {
         deep: true,
         handler (val, oldVal) {
            this.form = this.$inertia.form(this.old)
         }
      }
   },

   methods: {
      save () {
         this.loading = true
         const step = this.$page.props.steps.find(elem => elem.step.toString() === this.$page.props.step)
         const next = this.$page.props.steps.indexOf(step) + 1
         if (next < this.$page.props.steps.length) {
            this.form.post(this.route('questionnaire.store', [this.token]) + '?nextStep=' + this.$page.props.steps[next].step, { onFinish: () => { this.loading = false } })
         } else {
            this.form.post(this.route('questionnaire.store', [this.token]) + '?nextStep=complete', { onFinish: () => { this.loading = false } })
         }
      },
      complete () {
         this.form.post(this.route('questionnaire.complete', [this.token]), { onFinish: () => { this.loading = false } })
      }
   },
}
</script>

<style scoped>
</style>
